import React from 'react';
import { Section } from './ui/Section';
import { Moon } from 'lucide-react';
export function HowToUse() {
  return <Section data-id="element-119">
      <div className="text-center" data-id="element-120">
        <div className="inline-block p-3 bg-[#c9a04e]/10 rounded-full mb-6" data-id="element-121">
          <Moon className="w-8 h-8 text-[#c9a04e]" data-id="element-122" />
        </div>
        <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-12" data-id="element-123">
          Cómo se usa (literalmente)
        </h2>
      </div>

      <div className="max-w-sm mx-auto space-y-6 text-center" data-id="element-124">
        <p className="text-xl text-[#f5f0e8] border-b border-[#f5f0e8]/10 pb-4" data-id="element-125">
          15 minutos antes de dormir
        </p>
        <p className="text-xl text-[#f5f0e8] border-b border-[#f5f0e8]/10 pb-4" data-id="element-126">
          papel y bolígrafo
        </p>
        <p className="text-xl text-[#f5f0e8] border-b border-[#f5f0e8]/10 pb-4" data-id="element-127">
          sin pantallas
        </p>
        <p className="text-xl text-[#f5f0e8] border-b border-[#f5f0e8]/10 pb-4" data-id="element-128">
          7 noches seguidas
        </p>

        <p className="pt-8 text-[#8a9bb0] italic" data-id="element-129">
          Y si te despiertas: Protocolo 3:00am (sin improvisar).
        </p>
      </div>
    </Section>;
}